import { DK_ENVS } from './constants';
import { AsianRegions } from './types/promotions';

export const isAsianRegion = (casinoRegion: string, envId: number): boolean => {
  // consider Dk Env id as non asian
  if (DK_ENVS[envId]) return false;
  return casinoRegion === AsianRegions.Asia || casinoRegion === AsianRegions.Manila;
};
